import { daysOverdue } from './timezone';

// Statuses that place an agreement in the "archived" scope regardless of its dates.
export const ARCHIVED_AGREEMENT_STATUSES = ['expired', 'cancelled', 'inactive', 'terminated', 'deactivated'];

// Single source of truth for Current vs Archived classification, reused by the list,
// the renewal banner, the scope counts and the row actions.
// Archived when: status is expired/cancelled/deactivated, the record is explicitly
// deactivated (is_active === false), OR its end date has elapsed on the Central
// calendar. An end date of *today* is still Current (daysOverdue returns 0).
export function isAgreementArchived(agreement) {
  if (!agreement) return false;
  const status = String(agreement.status || '').trim().toLowerCase();
  if (ARCHIVED_AGREEMENT_STATUSES.includes(status)) return true;
  if (agreement.is_active === false) return true;
  return daysOverdue(agreement.end_date) > 0;
}

// Whether the Renew action should appear on an agreement row. All & Archived scopes
// must preserve Renew for archived records (expired/cancelled/inactive/deactivated or
// calendar-elapsed); any scope shows it for an upcoming renewal.
export function shouldShowRenew({ agreement, viewScope, isUpcomingRenewal }) {
  if (viewScope === 'archived') return true;
  if (isUpcomingRenewal) return true;
  return isAgreementArchived(agreement);
}
